angular.module('CarsSaraBo').controller('AdditionalsPriceController', ['$scope', '$routeParams','$q','PointOfSaleService','AdditionalPriceService',
    '$http','$location','SessionService',
    function($scope, $routeParams,$q, pointOfSaleService,additionalPriceService,$http,$location,session) {

        $scope.initialize = function() {
            $scope.loadCompany();
            $scope.loadData();
            $scope.editableAdditionalPrice = $scope.loggedUserAllowed('PERM_UPSELLING_CREATE');
        }

        $scope.loadCompany = function(){
            $scope.pointsOfSale= [];
            var fieldsPos="oid,name"
            pointOfSaleService.resource.query({companyOid: $routeParams.oid, fields:fieldsPos }, function(pointsOfSale) {
                $scope.pointsOfSale = pointsOfSale;
            });
        }

        $scope.loadData = function(){
            $scope.countryOid = session.session.countryOid;
            $scope.tollPerConsume = [];
            $scope.additionalPrices = [];
            $scope
            $http.get("../rest/data/additionals").success(function(response){
                $scope.additionals = _.filter(response, function (add) {
                    if(add.code.startsWith('TOLL')){
                        return false;
                    }
                    return true;
                });
                $scope.tollPerConsume = _.filter(response, function (add) {
                    if(add.code.startsWith('TOLL') && add.code != 'TOLL_UNLIMITED'){
                        return true;
                    }
                    return false;
                });
                $scope.unlimitedToll = _.find(response, function (add) {
                    if(add.code == 'TOLL_UNLIMITED' && $scope.countryOid == '20208'){
                        return true;
                    }
                    return false;
                });
                $scope.splitListIfEnsure(response);
                additionalPriceService.get({companyOid: $routeParams.oid }, function(additionalPrices) {
                    if(additionalPrices.length == 0 && $scope.loggedUserAllowed('PERM_UPSELLING_CREATE')) {
                        $location.path("/company/" +  $routeParams.oid + "/additionals/add" );
                    }
                    $scope.additionalPrices = additionalPrices;
                    $scope.priceMatrix=$scope.generatePriceMatrix($scope.additionalPrices);
                });
            });
        }

        $scope.splitListIfEnsure = function(additionals){
            $scope.ensureAdd=[];
            $scope.notEnsureAdd=[];
            additionals.forEach(function(e){
                e.ensureStock==true?$scope.ensureAdd.push(e):$scope.notEnsureAdd.push(e);
            });
        }


        $scope.generatePriceMatrix= function(additionalPrices){
            var priceMatrix = {};
            $scope.tollPerConsumePrice = {};

            additionalPrices.forEach(function(e){
                if(_.some($scope.tollPerConsume, function (toll) {
                        return toll.oid == e.additionalOid;
                    })){
                    $scope.tollPerConsumePrice = {oid: 'TOLL', posOid:e.posOid, code:'TOLL'}
                    priceMatrix[['TOLL',e.posOid]]={"baseAmount":e.baseAmount, "oid":e.oid};
                }else if(!!$scope.unlimitedToll && (e.additionalOid == $scope.unlimitedToll.oid)) {
                    priceMatrix[[e.additionalOid,e.posOid]]={"baseAmount":e.baseAmount, "oid":e.oid};
                }else{
                    priceMatrix[[e.additionalOid,e.posOid]]={"baseAmount":e.baseAmount, "oid":e.oid};
                }
            });
            return priceMatrix;
        };

        $scope.removeAdditionalPrice = function(oid){
            $scope.showModal("REMOVE_ALERT_TITLE", "REMOVE_ALERT_DESCRIPTION", function() {
                $q.all([
                    additionalPriceService.remove({companyOid: $routeParams.oid, oid: oid}).$promise,
                ]).then(function(response) {
                    $scope.initialize();
                    $scope.notifyInfoByCode('common.confirmationMessage.SUCCESS_DELETE');
                });
            });
        }

        $scope.editAdditionalPrice = function(addOid, posOid){
            $location.path("/company/" +  $routeParams.oid + "/additionals/" + $scope.priceMatrix[[addOid,posOid]].oid );
        }

        $scope.create = function(){
            $location.path("/company/" +  $routeParams.oid + "/additionals/add" )
        }

        $scope.initialize();
    }]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/general_conditions_controllers/additionals_price_controller.js
// module id = 912
// module chunks = 3